// removed by extract-text-webpack-plugin
module.exports = {"upload_preview":"upload_preview"};


//////////////////
// WEBPACK FOOTER
// ./src/yx-widget/component/YxInput/YxUpload/Components/preview.less
// module id = ./src/yx-widget/component/YxInput/YxUpload/Components/preview.less
// module chunks = 43